import React, { useMemo, useState, useEffect, useContext } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Box, Grid, } from "@mui/material";
import { useTranslation } from "react-i18next";
import DataTable from "../common/DataTable";
import { GET_EXPORT_BUDGET_PLANNING_REPORT, GET_EXPORT_SHIPMENT_REPORT, } from "../../services/apiRoutes";
import { AuthContext } from "../../context/AuthContext";
import { getCustumersList } from "../../services/CommonServices";
import CustomLoader from "../common/CustomLoader";
import CustomReport from "../common/CustomReport";
import { genericPost } from "../../services/authServices";
import CustomTextField from "../common/CustomTextField";
import CustomFilter from "../common/CustomFilter";
import CustomButton from "../common/CustomButton";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import { ClearRounded, } from "@mui/icons-material";
import CustomAutocomplete from "../common/CustomAutoComplete";
import { useCompanyDateFormat } from "../../constants/useCompanyDateFormat";
import CustomDataTable from "../common/CustomDataTable";
import { AccessDenied, hasCreatePermission, hasDeletePermission, hasEditPermission, hasViewPermission } from "../../services/CommonServices";
import { useLocation } from "react-router-dom";



const title = "Export Budget Planning Report";

const ExportBudgetPlanningReport = () => {
    const { t, i18n } = useTranslation();
    const companyDateFormat = useCompanyDateFormat();
    const navigate = useNavigate();
    const [permission, setPermissions] = useState()
    const [data, setData] = useState([]);
    const { token } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const filterOpen = () => setOpenDrawer(true);
    const filterClose = () => setOpenDrawer(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [custumersList, setCustumersList] = useState([]);
    const [page, setPage] = useState(0); // UI 0-based
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);

    const [filterPayload, setFilterPayload] = useState({
        shipmentId: '',
        customerNamesId: '',
        fromDate: '',
        toDate: '',

    });
    const location = useLocation();
    const currentPath = location.pathname;
    useEffect(() => {
        let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
        let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
        let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
        let createPermision = hasCreatePermission(currentPath, rolePermisionsData?.permissions)
        let viewPermision = hasViewPermission(currentPath, rolePermisionsData?.permissions)

        setPermissions({
            edit: editPermision,
            delete: deletePermission,
            create: createPermision,
            view: viewPermision,
        })
    }, [])
    const handleApplyFilter = async () => {
        setPage(0); // reset to first page
        setPageSize(rowCount);        // Auto select “All”
        await fetchData(0, ''); // 👈 pass empty pageSize to get all data with filters
        setOpenDrawer(false); // close filter drawer
    };


    const handleFilterChange = (field, value) => {
        setFilterPayload((prev) => ({
            ...prev,
            [field]: value || '',
        }));
    };
    const handleClearFilters = useMemo(() => {
        return () => {
            setFilterPayload({
                shipmentId: '',
                customerNamesId: '',
                fromDate: '',
                toDate: '',
            });
            fetchData(0, pageSize, '');
        };
    }, [pageSize]);


    useEffect(() => {
        getCommonData();
    }, []);
    const getCommonData = async () => {
        const custumersList = await getCustumersList();
        setCustumersList(custumersList);
    }
    const columns = useMemo(
        () => [
            {
                accessorKey: "index",
                header: "SN.",
                size: 50,
                tableHeader: { justifyContent: "center" },
                tableStyle: { textAlign: "center" }
            },

            {
                accessorKey: "shipmentId",
                header: "Shipment ID",
                size: 120,
                tableHeader: { justifyContent: "center" },
                tableStyle: { textAlign: "center" }
            },

            {
                accessorKey: "proformaInvoiceNo",
                header: "Proforma Invoice",
                size: 150,
                tableHeader: { justifyContent: "center" },
                tableStyle: { textAlign: "center" }
            },

            {
                accessorKey: "commercialInvoiceNo",
                header: "Commercial Invoice",
                size: 160,
                tableHeader: { justifyContent: "center" },
                tableStyle: { textAlign: "center" }
            },


            {
                accessorKey: "seaFreight",
                header: "Sea Freight",
                size: 120,
                tableHeader: { justifyContent: "flex-end" },
                tableStyle: { textAlign: "right" }
            },

            {
                accessorKey: "clearingAgencyCharge",
                header: "Clearing Agency Charge",
                size: 180,
                tableHeader: { justifyContent: "flex-end" },
                tableStyle: { textAlign: "right" }
            },

            {
                accessorKey: "freightForwardAgencyCharge",
                header: "Freight Forward Charge",
                size: 190,
                tableHeader: { justifyContent: "flex-end" },
                tableStyle: { textAlign: "right" }
            },

            {
                accessorKey: "cfsLocalCharges",
                header: "CFS Local Charges",
                size: 150,
                tableHeader: { justifyContent: "flex-end" },
                tableStyle: { textAlign: "right" }
            },

            {
                accessorKey: "shippingLineCharges",
                header: "Shipping Line Charges",
                size: 170,
                tableHeader: { justifyContent: "flex-end" },
                tableStyle: { textAlign: "right" }
            },

            {
                accessorKey: "blCharges",
                header: "BL Charges",
                size: 120,
                tableHeader: { justifyContent: "flex-end" },
                tableStyle: { textAlign: "right" }
            },

            {
                accessorKey: "othersCharges",
                header: "Other Charges",
                size: 140,
                tableHeader: { justifyContent: "flex-end" },
                tableStyle: { textAlign: "right" }
            },

            {
                accessorKey: "dutyCharge",
                header: "Duty",
                size: 120,
                tableHeader: { justifyContent: "flex-end" },
                tableStyle: { textAlign: "right", fontWeight: 500 }
            },

            {
                accessorKey: "taxCharge",
                header: "Tax",
                size: 120,
                tableHeader: { justifyContent: "flex-end" },
                tableStyle: { textAlign: "right", fontWeight: 500 }
            },

            {
                accessorKey: "transportCharge",
                header: "Transport Charge",
                size: 160,
                tableHeader: { justifyContent: "flex-end" },
                tableStyle: { textAlign: "right" }
            },
            {
                accessorKey: "conversionRate",
                header: "conversion Rate",
                size: 160,
                tableHeader: { justifyContent: "flex-end" },
                tableStyle: { textAlign: "right" }
            },

        ],
        [permission]
    );
    const fetchData = async (pageIndex = 0, pageSizeValue = pageSize,) => {
        setLoading(true);
        try {
            const payload = {
                page: pageIndex + 1,
                limit: pageSizeValue || '',
                ...filterPayload
            };
            const response = await genericPost(GET_EXPORT_BUDGET_PLANNING_REPORT, payload, {});
            if (response.data.success && response.data.planningBudget) {

                const shipmentData = response.data.planningBudget.map((item, index) => {

                    const baseCurrency = item?.baseCurrency?.currency_symbol || '';
                    const currencySymbol = item?.currency?.currency_symbol || '';

                    const formatAmount = (value) =>
                        `${baseCurrency} ${parseFloat(value || 0).toFixed(2)}`;
                    const formatAmountCompany = (value) =>
                        `${currencySymbol} ${parseFloat(value || 0).toFixed(2)}`;

                    return {
                        index: index + 1,

                        shipmentId: item.shipmentId || '',

                        proformaInvoiceNo: item?.ProformaInvExp?.proformaInvoiceNo || '',

                        commercialInvoiceNo: item?.CommercialInvExp?.commercialInvoiceNo || '',

                        seaFreight: formatAmountCompany(item.seaFreight),

                        clearingAgencyCharge: formatAmount(item.clearingAgencyCharge),

                        freightForwardAgencyCharge: formatAmount(item.freightForwardAgencyCharge),

                        cfsLocalCharges: formatAmount(item.cfsLocalCharges),

                        shippingLineCharges: formatAmount(item.shippingLineCharges),

                        blCharges: formatAmount(item.blCharges),

                        othersCharges: formatAmount(item.othersCharges),

                        dutyCharge: formatAmount(item.dutyCharge),

                        taxCharge: formatAmount(item.taxCharge),

                        transportCharge: formatAmount(item.transportCharge),
                        conversionRate: formatAmount(item.conversionRate),
                    };
                });
                setData(shipmentData);
                setRowCount(response.data.pagination?.totalRecords || 0);

            } else {
                setError('No import shipments found');
            }
        } catch (error) {
            setError('Error fetching import shipments');
            console.error('Error fetching import shipments', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(page, pageSize)
    }, [token, page, pageSize])

    const defaultView = 'exportbudgetplanningreport';
    const mainContent = (
        <>
            <CustomLoader open={loading} />
            <CustomDataTable
                title={title}
                columns={columns}
                data={data}
                handleFilterButton={filterOpen}
                fiterButtonTitile="Fiter"
                rowCount={rowCount}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                fromDate={filterPayload.fromDate || ""}
                toDate={filterPayload.toDate || ""}

            />
            <CustomFilter
                drawerTitle="Filter Options"
                drawerWidth={300}
                openDrawer={openDrawer}
                onClose={filterClose}
                drawerContent={
                    <>
                        <Box>
                            <Grid container spacing={1} sx={{ padding: 0, }}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        type="text"
                                        placeholder="Enter Shipment ID"
                                        value={filterPayload.shipmentId}
                                        onChange={(e) => handleFilterChange('shipmentId', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomAutocomplete
                                        options={custumersList}
                                        getOptionLabel={(option) => option.title}
                                        placeholder="Select Customer"
                                        value={custumersList.find((item) => item.id === filterPayload.customerNamesId) || null}
                                        onChange={(event, newValue) => handleFilterChange("customerNamesId", newValue?.id)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        fieldLabel="from Date"
                                        type="date"
                                        value={filterPayload.fromDate}
                                        onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                                        placeholder="From Date"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        fieldLabel="to Date"
                                        type="date"
                                        value={filterPayload.toDate}
                                        onChange={(e) => handleFilterChange('toDate', e.target.value)}
                                        placeholder="To Date"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>
                                    <CustomButton
                                        startIcon={<FindReplaceOutlinedIcon />}
                                        title="Apply"
                                        size="small"
                                        variant="contained"
                                        // onClick={fetchData}
                                        onClick={handleApplyFilter} // 👈 updated

                                    />
                                    <CustomButton
                                        variant="outlined"
                                        title="Clear"
                                        startIcon={<ClearRounded />}
                                        onClick={handleClearFilters}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </>
                }
            />
        </>
    );
    const getMainContent = (mainContent, permission) => {
        return permission?.view ? mainContent : null;
    };

    return (
        <>
            <>
                <CustomReport
                    defaultView={defaultView}
                    mainContent={getMainContent(mainContent, permission)} />
                {!permission?.view && <AccessDenied />}
            </>
        </>
    );
};
export default ExportBudgetPlanningReport;
